import React, { useCallback, useState } from "react";
import i18n from "../../../i18n/config";
import useErrorModal from "../../../hooks/useErrorModal";

// ui component
import SendMoneyLimitsContent from "./SendMoneyLimitsContent";
import DynamicModal from "../../Common/DynamicModal";
import Action from "../../Common/Action";

interface SendMoneyLimitsModalProps {
  open: boolean;
  setClose: React.Dispatch<React.SetStateAction<boolean>>;
}

const SendMoneyLimitsModal = ({
  open,
  setClose,
}: SendMoneyLimitsModalProps): React.ReactElement => {
  const [title, setTitle] = useState("");
  const openErrorModal = useErrorModal();

  // limits failed: hand off to ApiErrorModal and close rather than stack
  const handleLimitsError = useCallback(
    (err: unknown) => {
      openErrorModal(err);
      setClose(false);
    },
    [openErrorModal, setClose]
  );

  return (
    <DynamicModal
      open={open}
      setClose={setClose}
      showCloseIcon={true}
      className="v3 max-w-350 min-w-350"
      variant="tight"
      header={<p className="bold text-primary font-size-lg mb-0">{title}</p>}
      body={<SendMoneyLimitsContent onTitle={setTitle} onError={handleLimitsError} />}
      footer={
        <Action
          onClick={() => setClose(false)}
          type="button"
          title={i18n.t("COMMON.CLOSE")}
          className="w-full"
        />
      }
    />
  );
};

export default SendMoneyLimitsModal;